function hideCartTitleIfEmpty() {
  const cartTitle = document.querySelector('.section__title-text');
  const cartItemsContainer = document.querySelector('.gr-cart__items'); 
  const cartItems = cartItemsContainer ? cartItemsContainer.children.length : 0;

  if (cartTitle) {
      if (cartItems === 0) {
          cartTitle.style.display = 'none';
      } else {
          cartTitle.style.display = 'block';
      }
  }
}

document.addEventListener('DOMContentLoaded', hideCartTitleIfEmpty);

document.addEventListener('click', function (event) {
  if (event.target.matches('.gr-cart-item__remove') || event.target.closest('.gr-cart-item__remove')) {
      setTimeout(hideCartTitleIfEmpty, 500);
  }
});

const observer = new MutationObserver(hideCartTitleIfEmpty);
const cartContainer = document.querySelector('.gr-cart__items');
if (cartContainer) {
  observer.observe(cartContainer, { childList: true, subtree: true });
}
